// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeUploadCompleteBody = {
  mediaId: string;
  requestId: string;
};

export type typeUploadCompleteOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    mediaId: string;
    purpose: "avatar" | "poolBanner" | "chatPhoto" | "chatPdf";
    status: "published" | "pendingReview" | "heldOnBudget";
    variants?: {
      original: { url: string; width: number; height: number };
      large: { url: string; width: number; height: number };
      thumbnail: { url: string; width: number; height: number };
    } | null;
    publishedAt?: string | null;
  };
};

export type typeUploadCompleteOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeUploadCompleteOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeUploadCompleteOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaUploadCompleteBody = {
  type: "object",
  properties: {
    mediaId: { type: "string", maxLength: 3000, minLength: 1 },
    requestId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["mediaId", "requestId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createUploadComplete(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaUploadCompleteBody);
  }

  return async function postUploadComplete(
    payload: typeUploadCompleteBody,
  ): Promise<typeUploadCompleteOutput200 | typeUploadCompleteOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postUploadComplete" failed before calling the network. #cd203420397a`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#cd203420397a" },
        },
        data: null,
      } as typeUploadCompleteOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/upload/complete`,
      httpMethod: "POST",
      options,
    })) as typeUploadCompleteOutput200 | typeUploadCompleteOutput400;
  };
}
